<script>
import baseview from '@/components/base/baseview'
import {fn_Login } from '@/framework/login/login'
import {getFnDecrypt } from '@/api/common/login'
import Cookies from 'js-cookie'
import LoginFail from '@/layout/login/LoginFail'
import router from '@/router'

export default {
  name: 'moceanLogin',
  mixins: [baseview],
  components: {
    LoginFail,
  },
  data() {
    return {
      showPassword:false,
      showFail: false,
      userData: {
        userId: '',
        userPw: '' ,
        sysId:'',
      },
      
      isSaveID: false,
      snackbar: false,
      msg: '',
      timeout: 2000,       
    }
  },
  created() {
    //alert('MoceanLogin.vue created!')
  },
  mounted() {  
    this.loadData()   
  }, 
  methods: {
    async loadData() {
      this.isLoading = true;
      try {
        const userId = this.$route.query.user_id
        //alert(`moceanLogin methods ${userId}`) 
        if(userId){
          this.userData.userId = userId
          this.userData.userPw = 'MOCEAN'
          this.userData.sysId = this.$store.state.system.sysCd
        }else{
          //console.error("go to USER:");
          await this.getFnDecrypt();
        }      

        await this.signIn();
      } catch (error) {
        alert('Error on loading user data');
      } finally {
        this.isLoading = false; // Kết thúc loading
      }
    },
    async getFnDecrypt(){
      let param = {
        userId : this.$route.query.user_id
      }
      const res = await getFnDecrypt(param)
      this.userData.userId = res.USR_ID     
    },
    signIn() { 
       fn_Login(this.userData).then((res) => {
           if (res.result) {    
             const sysCd = this.$store.state.system.sysCd 
             let view = '/v' + sysCd + 'main'
              //alert(view)
              if(view) {
                this.$router.push(view).catch((e => {
                  this.vToastify(this.$t('View does not exist.'), 'warn')
                }));
              }
           } else {
             if(res.msg !== 'loginFail') {
               this.snackbar = true
               this.msg = res.msg
             } else {
               this.showFail = true
             }
           }
         })
    },   
  },
}
</script>